import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["template", "tbody"]
  static values = { isNew: Boolean }

  connect() {
    if (this.isNewValue) return
    if (!this.hasTbodyTarget || !this.hasTemplateTarget) return

    this.fill()
    this.resizeObserver = new ResizeObserver(() => this.fill())
    const container = this.scrollContainer()
    if (container) this.resizeObserver.observe(container)
  }

  disconnect() {
    if (this.resizeObserver) this.resizeObserver.disconnect()
  }

  fill() {
    const container = this.scrollContainer()
    if (!container) return

    this.tbodyTarget.querySelectorAll('.referral-placeholder-row').forEach(el => el.remove())

    const realRows = this.tbodyTarget.querySelectorAll('tr:not(.referral-placeholder-row)')
    if (realRows.length === 0) return

    const rowHeight = realRows[0].offsetHeight
    if (rowHeight <= 0) return

    const lastRow = realRows[realRows.length - 1]
    const containerRect = container.getBoundingClientRect()
    const lastRowRect = lastRow.getBoundingClientRect()
    const availableHeight = containerRect.bottom - lastRowRect.bottom

    const placeholderCount = Math.max(0, Math.round(availableHeight / rowHeight))
    if (placeholderCount === 0) return

    for (let i = 0; i < placeholderCount; i++) {
      const clone = this.templateTarget.content.firstElementChild.cloneNode(true)
      this.tbodyTarget.appendChild(clone)
    }
  }

  scrollContainer() {
    return this.element.closest('.inbound-subtable-container')
  }
}
